// Per-language regexes built from the vocab's regex BODIES (prompts/<lang>/
// vocab.json holds bare alternations like "s[iì]|esatto|…", no boundaries —
// the backend wraps the same bodies as \b(BODY)\b). JS's \b is ASCII-only,
// so it misses a word edge next to accented letters ("sì," / "così,");
// boundaries here use Unicode-letter lookarounds instead.
import { vocab } from "./prompts";

export const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const wordRe = (body) => new RegExp(`(?<![\\p{L}\\p{N}_])(${body})(?![\\p{L}\\p{N}_])`, "iu");

// One compiled value per (key, lang), built lazily.
const CACHE = new Map();
export function perLang(key, lang, build) {
  const k = `${key}\u0000${lang}`;
  if (!CACHE.has(k)) CACHE.set(k, build(vocab(lang)));
  return CACHE.get(k);
}

// [[regex, value]] for parsing a one-word classifier answer (yes/no/unclear):
// the Italian tokens are always accepted — the historical answer words, which
// a model may still emit whatever the UI language — plus the current
// language's own tokens. Twin of pocketflow_agents._answer_res.
export function answerRes(lang) {
  return perLang("answer", lang, (cur) => {
    const it = vocab("it");
    return [["yes_tokens", true], ["no_tokens", false], ["unclear_tokens", null]].map(([key, value]) => {
      const tokens = [...new Set([...it[key], ...(cur[key] || [])])];
      return [wordRe(tokens.map(escapeRe).join("|")), value];
    });
  });
}
